import { ActionType } from '../action-types';
import accountInitialState from './init/accountInitialState'

const accountReducer = (state = accountInitialState, action) => {
    switch (action.type) {
        case ActionType.LOGOUT:
        case ActionType.LOGIN_SUCCESS:
            return accountInitialState;

        case ActionType.VALIDATION_SUCCESS:
            return {
                ...state,
                [action.field + 'State']: "success",
                [action.field]: action.value
            }

        case ActionType.VALIDATION_FAILURE:
            return {
                ...state,
                [action.field + 'State']: "error",
            }
        case ActionType.EMAIL_EXISTS:
            return {
                ...state,
                emailExists: true
            }
        case ActionType.CLOSE_EDIT_ACCOUNT_NOTIFICATION:
            return {
                ...state,
                editAccountSuccess: false,
                editAccountFail: false,
                emailOrPhoneAlreadyTaken: false,
                disableEditAccountButton: false
            }
        case ActionType.EDIT_ACCOUNT_SUCCESS:
            return {
                ...state,
                editAccountSuccess: true,
                editAccountFail: false,
                disableEditAccountButton: false
            }
        case ActionType.EDIT_ACCOUNT_FAIL:
            return {
                ...state,
                editAccountSuccess: false,
                editAccountFail: true,
                disableEditAccountButton: false
            }
        case ActionType.DISABLE_EDIT_ACCOUNT_BUTTON:
            return {
                ...state,
                disableEditAccountButton: true
            }
        case ActionType.NOTIFICATION_SETTINGS_UPDATE: {
            let account = state.account;
            account?.systemsDetails?.forEach((sys) => {
                if (sys.ID == action.systemID) {
                    Object.keys(action.pushSettings).forEach(key => {
                        sys[`pushNotifications${key}`] = action.pushSettings[key];
                    });
                    Object.keys(action.emailSettings).forEach(key => {
                        sys[`emailNotifications${key}`] = action.emailSettings[key];
                    });
                    Object.keys(action.emailSettings).forEach(key => {
                        sys[`smsNotifications${key}`] = action.smsSettings[key];
                    });
                    sys.AssignmentUpdatedAt = action.updatedAt;
                }
            });
            return {
                ...state,
                notificationSettingsUpdatedSuccessfully: true,
                notificationSettingsUpdatedFailed: false,
                updatedSystemNotificationId: action.systemID,
                account: account
            };
        }
        case ActionType.REFRESH_USER_NAME:
            return {
                ...state,
                name: action.value
            };
        case ActionType.EMAIL_OR_PHONE_ALREADY_TAKEN:
            return {
                ...state,
                emailOrPhoneAlreadyTaken: true,
                disableEditAccountButton: false
            };
        case ActionType.DETACH_ACCOUNT_FROM_SYSTEM:
            return {
                ...state,
                detachConfirmed: action.detachConfirmed
            }
        case ActionType.WAS_FETCHED_VISIBLE_SYSTEMS_FOR_ACCOUNT:
            return {
                ...state,
                wasFetchedVisibleSystems: action.wasFetchedVisibleSystems
            }
        case ActionType.UNREGISTER_FROM_MOBILE_APP:
            return {
                ...state,
                unregisterFromMobileAppConfirmed: action.unregisterFromMobileAppConfirmed
            }
        case ActionType.UPDATE_ACCOUNT_PICKED_SYSTEM_NAME: {
            return {
                ...state,
                isAccountFilteredSystemNameUpdated: action.payload,
            };
        }
        case ActionType.SHOW_ACCOUNT_FILTERED_SYSTEMS: {
            return {
                ...state,
                accountFilteredSystems: action.payload,
            };
        }
        case ActionType.SHOW_ACCOUNT_FILTERED_SYSTEMS_NAMES: {
            return {
                ...state,
                accountFilteredSystemsNames: action.payload,
            };
        }
        case ActionType.SHOW_ACCOUNT_SYSTEM_SEARCH_BAR: {
            return {
                ...state,
                isAccountSystemSearchBarVisible: action.payload,
            };
        }
        case ActionType.SET_ASKED_ACCOUNT_ID: {
            return {
                ...state,
                askedAccountId: action.askedAccountId,
            };
        }
        case ActionType.GET_ACCOUNT: {
            let forbidden = false;
            if (action.account.id === 0) {
                forbidden = true;
            }
            return {
                ...state,
                account: action.account,
                forbidden: forbidden
            };
        }
        case ActionType.CLEAR_ACCOUNT_DATA: {
            return {
                ...state,
                account: null,
                forbidden: false,
                isAccountSystemSearchBarVisible: true,
                accountFilteredSystems: [],
                accountFilteredSystemsNames: [],
                isAccountFilteredSystemNameUpdated: false
            };
        }
        default:
            return state;
    }
}

export default accountReducer;